export const translations = {
  sair: {
    pt: 'Sair',
    en: 'Exit',
    de: 'Schließen',
    es: 'Salir',
  },
  logged_in_as: {
    pt: 'Logado como:',
    en: 'Logged in as:',
    de: 'Angemeldet als:',
    es: 'Conectado como:',
  },
};
